module.exports = __webpack_public_path__ + "static/media/transparent.2f3adce0.svg";